import { Component, OnInit } from "@angular/core";
import { FeatureFlagsService } from "@cotecna/feature-manager";
import { LogoutService } from "./session/services/logout/logout.service";
import { FeatureFlagsService as FFService } from "src/app/shared/services/feature-flags/feature-flags.service";
import { MatIconRegistry } from "@angular/material/icon";

@Component({
    selector: "im-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    public featureFlagService: FeatureFlagsService,
    public eyeFFService: FFService,
    private logoutService: LogoutService,
    private matIconRegistry: MatIconRegistry,
  ) {
    matIconRegistry.setDefaultFontSetClass("material-icons-outlined");
  }

  async ngOnInit() {
    await this.featureFlagService.initialize();
    this.logoutService.logoutOnIdleTime();
  }

  public showMaintenanceMessage(): boolean {
    return this.eyeFFService.showMaintenanceMessage();
  }
}
